import mock from './mock';
import './navbar/navbarSearch';
import './navbar/navbarBookmarkSearch';
import './auth/authentication';
import './User/userFranchises';
import './User/userFranchises';
mock.onAny().passThrough();
